export default __webpack_public_path__ + "static/media/no-video.bf7aecc0.png";